import { styled } from '@mui/material/styles';
import { Typography, Paper, Box } from '@mui/material';

const PREFIX = 'OnboardForm';

export const formClasses = {
  container: `${PREFIX}-container`,
  formcontainer: `${PREFIX}-formcontainer`,
  title: `${PREFIX}-title`,
  subtitle: `${PREFIX}-subtitle`,
  control: `${PREFIX}-control`,
  checkbox: `${PREFIX}-checkbox`,
  disclaimer: `${PREFIX}-disclaimer`,
  wide: `${PREFIX}-wide`,
  button: `${PREFIX}-button`,
};

const Root = styled(Paper)(({ theme }) => ({
  [`&.${formClasses.container}`]: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    padding: theme.spacing(2),
    width: 564,
    marginLeft: 'auto',
    [theme.breakpoints.up('md')]: {
      marginRight: 12,
    },
    [theme.breakpoints.down('md')]: {
      marginRight: 'auto',
    },
    overflowY: 'auto',
  },

  [`& .${formClasses.formcontainer}`]: {
    marginLeft: theme.spacing(5),
  },

  [`& .${formClasses.disclaimer}`]: {
    color: theme.palette.text.secondary,
    fontSize: '0.875rem',
    marginTop: theme.spacing(1),
  },

  [`& .${formClasses.title}`]: {
    fontFamily: 'Bitter',
  },

  [`& .${formClasses.subtitle}`]: {
    marginTop: theme.spacing(1),
    fontWeight: 700,
    fontFamily: 'Bitter',
    fontSize: 20,
    '&:not(:first-child)': {
      marginTop: theme.spacing(4),
    },
  },

  [`& .${formClasses.control}`]: {
    marginTop: theme.spacing(2),
    minWidth: 320,
  },

  [`& .${formClasses.checkbox}`]: {
    marginTop: theme.spacing(2),
    display: 'block',
  },

  [`& .${formClasses.wide}`]: {
    width: '100%',
  },
}));

interface OnboardFormProps {
  title: string;
  children: React.ReactNode;
}

export default function OnboardForm({ title, children }: OnboardFormProps) {
  return (
    <Root elevation={2} className={formClasses.container}>
      <Typography variant="h4" className={formClasses.title}>
        {title}
      </Typography>
      <Box className={formClasses.formcontainer}>{children}</Box>
    </Root>
  );
}
